let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fhoQ2")).then(() => parcelRequire('5Pm4u'));